import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { GameDB } from "./Games";

export const updateGameStatus = async (gameId: string, status: boolean) => {
  const collectionRef = collection(db, "games");

  await updateDoc(doc(collectionRef, gameId), {
    isActive: status,
    updatedAt: new Date(),
  });

  const gameSnapshot = await getDoc(doc(collectionRef, gameId));

  const updatedGame = new GameDB(gameSnapshot);

  return updatedGame.toGame();
};
